// @ts-nocheck

import color from 'color';
import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';

const colorLight = color('#dddddd');

const Button = styled.button`
  && {
    :active {
      background-color: ${colorLight.darken(0.2).string()};
    }
  }
`;

type GridsFastButtonProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
};

const GridsFastButton = ({ children, className, onClick, style }: GridsFastButtonProps) => {
  const ref = useRef(null);

  const onTouchStart = useCallback(
    (e) => {
      e.preventDefault();
      if (typeof onClick === 'function') {
        onClick();
      }
    },
    [onClick],
  );

  useEffect(() => {
    const refCurrent = ref?.current;

    if (refCurrent) {
      refCurrent.addEventListener('touchstart', onTouchStart);
    }

    return () => {
      refCurrent.removeEventListener('touchstart', onTouchStart);
    };
  }, [onTouchStart]);

  return (
    <Button ref={ref} style={style} className={className}>
      {children}
    </Button>
  );
};

export default GridsFastButton;
